import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {

  EstadoComponente,
  GeneralTable,

} from "@/shared/components/ui";
import { useGetSolicitudesIngreso } from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import {
  EstadosSolicitudIngresoEnum,
  IDataProducto,
  SolicitudesIngreso,
} from "@/shared/interfaces";
import { Button, Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { PermissionsEnum } from "@/auth/interfaces";
import { cellNotFilter, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from "@/shared";
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";


export default function SolicitudIngresoRechazadosPagina() {
  //useCheckPermissions(PermissionsEnum.api_add_solicitudingreso);
  useCheckPermissions(PermissionsEnum.api_view_solicitudingreso)
  //*store
  const handleCragarListaProductos = useSinSeriesProducto(s => s.handleCargarListaProductos)
  const listaProducto = useSinSeriesProducto(s => s.listaProducto)
  const paginatedProductoData = useSinSeriesProducto(s => s.paginatedProductoData)
  const paginationSample = useSinSeriesProducto(s => s.pagination)
  const setPaginationSample = useSinSeriesProducto(s => s.setPagination)
  const clearSelectedItems = useSinSeriesProducto(s => s.clearSelectedItems)

  //state
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [details, setDetails] = useState<IDataProducto[]>([]);

  //columns
  const columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: "detalle",
        header: "Producto",
        size: 100,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={() => { onDetails(row.original) }}
            >
              {'Ver'}
            </Button>
          );
        },
      },

      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_data.nombre",
        header: "ubicacion",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "observaciones.observacionRevision",
        header: "observación del Revisor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionRevision || 'N/A'
            }
            title="Observación del Revisor"
          />
        )
      },
      {
        accessorKey: 'motivo_rechazo',
        header: "Motivo Rechazado",

        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={
              row.original.motivo_rechazo || 'N/A'
            }
            title="Motivo"
          />
        )
      },
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "Usuario",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="red"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );

  const onDetails = (e: MRT_RowData) => {

    // setDetails(e.productos)
    //setDetails(JSON.parse(e.detalle));
    handleCragarListaProductos(e.productos)
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IDataProducto>[] =
    useMemo<MRT_ColumnDef<IDataProducto>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Unidad Medida',
          Cell: ({ row }: any) => row.original.producto_data?.unidad_medida || 'N/A'
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
      ],
      []
    );

  const {
    // globalFilter,
    pagination,
    searchTerm,
    //onChangeFilter,
    setPagination,

    dateBefore,
    dateAfter,
    //onChangeRangeDate,
    //cleanFilter
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();
  const {
    data: solicitudPedidoIngresosRechazadosRes,
    isLoading,
    isRefetching,
  } = useGetSolicitudesIngreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.RECHAZADO,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
    ...filterObject,
    filterByState: false
  });
  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <GeneralTable<SolicitudesIngreso>
          columns={columns}
          data={solicitudPedidoIngresosRechazadosRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidoIngresosRechazadosRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          ////
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalle Producto"
        onCloseIcon={() => { setIsModalOpen(false), clearSelectedItems() }}
        minWidth="60%"
        contentNode={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination<IDataProducto>
                columns={columnsProductosDetallePedidosDb}
                data={paginatedProductoData}
                rowCount={listaProducto.length}
                pagination={paginationSample}
                setPagination={setPaginationSample}
                rowNumber={true}
              />
              {/* {details.length > 0 && (
                <SampleTable<IDataProducto>
                  columns={columnsProductosDetallePedidosDb}
                  data={details}
                />
              )} */}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
}
